import {useEffect} from "react";
import {Control, Controller} from "react-hook-form";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import "./TextInputWithIcon.scss";
import {RequestType} from "../../models/Request";

export interface TextInputWithIconProps {
    id: string;
    type?: string;
    value: string | number;
    onValueChange: (property: string, value: string) => void;
    labelText: string;
    icon: string;
    iconAlign: string;
    placeholderText: string;
    control: Control;
    setValue?: any;
    errors: any;
    rules?: any;
    readOnly?: boolean;
    disabled?: boolean;
    onKeyPress?: (e: any) => void;
    colorType?: string;
};

export const TextInputWithIcon = (p: TextInputWithIconProps) => {
    const {
        id,
        type,
        value,
        onValueChange,
        labelText,
        icon,
        iconAlign,
        placeholderText,
        control,
        setValue,
        errors,
        rules,
        readOnly,
        disabled,
        onKeyPress,
        colorType
    } = p;

    useEffect(() => {
        if (setValue) setValue(labelText, value)
    }, [value]);

    return (
        <div className="text-input-with-icon">
            <label
                className={classNames("text-label", {
                    'p-error': errors[labelText],
                })}
                htmlFor={id}
            >
                {labelText}
            </label>
            <div className={ iconAlign === 'left' ? "p-input-icon-left" : "p-input-icon-right" }>
                <Controller
                    name={labelText}
                    control={control}
                    rules={rules}
                    render={({ field, fieldState }) => (
                        <InputText
                            {...field}
                            id={id}
                            type={type}
                            value={value}
                            onChange={(e)=>{
                                field.onChange(e);
                                onValueChange(id, e.target.value)}}
                            className={classNames(
                                'text-input-field',
                                { 'text-input-field-request-import': colorType === RequestType.Import },
                                { 'text-input-field-request-export': colorType === RequestType.Export },
                                { 'text-input-field-request-relocation': colorType === RequestType.Relocation },
                                { 'p-invalid': fieldState.invalid }
                            )}
                            placeholder={placeholderText}
                            readOnly={readOnly}
                            disabled={disabled}
                            onKeyPress={onKeyPress}
                        />
                    )}
                />
                <span className="textinput-icon-wrapper">
                    <i className={icon + " textinput-icon"} />
                </span>
            </div>
        </div>
    );
};
